import { Container, Heading, Text } from 'components/saved-credits/NoSavedCredit/components';
import BackToResultButton from 'components/common/BackToResultButton';

import FlexContainer from 'components/common/FlexContainer';
import { Heart } from 'react-feather';
import { NavContainer } from '../SavedCreditsList/components';

export default function NoSavedCredit(): JSX.Element {
  return (
    <Container className='saved-credits-container'>
      <NavContainer className='saved-credits-nav-container' flexDirection='row' justifyContent='space-between'>
        <BackToResultButton />
      </NavContainer>
      <Heading>No saved credit</Heading>
      <FlexContainer gap={4}>
        <Text>To save a match for later, press</Text>
        <FlexContainer flexDirection='row' alignItems='center' justifyContent='center' gap={4}>
          <Text>the</Text>
          <Heart size={16} />
          <Text>icon on a credit match.</Text>
        </FlexContainer>
      </FlexContainer>
    </Container>
  );
}
